<div fxLayout class="sbnb-onboarding mb-6 items-center justify-center p-8">
  <ng-container [ngSwitch]="pageLoadingState$ | async">
    <ng-container *ngSwitchCase="LoadingState.Pending">
      <div fxLayout style="margin-bottom: 24px; align-items: center; justify-content: center">
        <mat-spinner fxLayout fxLayoutAlign="center" [diameter]="30"></mat-spinner>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="LoadingState.Success">
      <sbnb-signup-header></sbnb-signup-header>
      <ng-container *ngIf="listingReviews; else reviewListingsNoData">
        <ng-template [ngTemplateOutlet]="reviewListingsV1"></ng-template>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="LoadingState.Error">
      <ng-template [ngTemplateOutlet]="reviewListingsError"></ng-template>
    </ng-container>
  </ng-container>

  <ng-template #reviewListingsNoData>
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
      <div>
        <svg width="90" height="82" viewBox="0 0 90 82" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.47656 42.3789L40.9009 3.92191C42.0504 2.77921 43.607 2.14019 45.2278 2.14554C46.8486 2.15089 48.4009 2.80016 49.5429 3.95042L87.9998 42.3789"
            stroke="#E5E2E9"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M75.7819 30.169V79.0313H14.6938V30.1487"
            stroke="#E5E2E9"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M33 43C33 44.6569 31.6569 46 30 46C28.3431 46 27 44.6569 27 43C27 41.3431 28.3431 40 30 40C31.6569 40 33 41.3431 33 43ZM63 43C63 44.6569 61.6569 46 60 46C58.3431 46 57 44.6569 57 43C57 41.3431 58.3431 40 60 40C61.6569 40 63 41.3431 63 43ZM37.9152 59.8545C37.1972 60.2678 36.2801 60.0209 35.8668 59.3029C35.4534 58.585 35.7004 57.6679 36.4183 57.2546C39.3867 55.5455 47.0985 53.4341 55.4995 57.6005C56.2417 57.9686 56.5449 58.8686 56.1768 59.6108C55.8088 60.353 54.9087 60.6562 54.1666 60.2882C46.8001 56.6348 40.1545 58.5651 37.9152 59.8545Z"
            fill="#D0CDD4" />
        </svg>
      </div>

      <h2>No listings found</h2>

      <span class="text-center">
        {{ 'CORE.PRODUCT_NAME' | transloco }} did not find any listings under this account.
        <br />
        You need at least one listing to test out the features available on {{ 'CORE.PRODUCT_NAME' | transloco }}.
      </span>

      <ng-template [ngTemplateOutlet]="complete"></ng-template>
    </div>
  </ng-template>

  <ng-template #reviewListingsError>
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
      <div>
        <svg width="90" height="82" viewBox="0 0 90 82" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.47656 42.3789L40.9009 3.92191C42.0504 2.77921 43.607 2.14019 45.2278 2.14554C46.8486 2.15089 48.4009 2.80016 49.5429 3.95042L87.9998 42.3789"
            stroke="#E5E2E9"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M75.7819 30.169V79.0313H14.6938V30.1487"
            stroke="#E5E2E9"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M33 43C33 44.6569 31.6569 46 30 46C28.3431 46 27 44.6569 27 43C27 41.3431 28.3431 40 30 40C31.6569 40 33 41.3431 33 43ZM63 43C63 44.6569 61.6569 46 60 46C58.3431 46 57 44.6569 57 43C57 41.3431 58.3431 40 60 40C61.6569 40 63 41.3431 63 43ZM37.9152 59.8545C37.1972 60.2678 36.2801 60.0209 35.8668 59.3029C35.4534 58.585 35.7004 57.6679 36.4183 57.2546C39.3867 55.5455 47.0985 53.4341 55.4995 57.6005C56.2417 57.9686 56.5449 58.8686 56.1768 59.6108C55.8088 60.353 54.9087 60.6562 54.1666 60.2882C46.8001 56.6348 40.1545 58.5651 37.9152 59.8545Z"
            fill="#D0CDD4" />
        </svg>
      </div>

      <h2>Oops, an error has occurred</h2>

      <ng-template [ngTemplateOutlet]="complete"></ng-template>
    </div>
  </ng-template>

  <ng-template #reviewListingsV1>
    <div fxLayout="column" fxLayoutGap="24px" *ngIf="listingReviews">
      <section fxLayout="column" fxLayoutGap="20px">
        <h2>Review imported listings</h2>
        <span>
          {{ 'CORE.PRODUCT_NAME' | transloco }} has imported 🏠
          <strong>
            {{ listingReviews.meta.total_listings }} listing{{ listingReviews.meta.total_listings > 1 ? 's' : '' }}
          </strong>
          from your {{ platformString }} account. You can view the list of imported listings below.
        </span>
      </section>

      <section>
        <mat-tab-group>
          <mat-tab *ngFor="let tab of listingReviews.types" [label]="tabNames[tab]">
            <div *ngIf="tab === 'archived'" class="listing-warning" fxLayout="column" fxLayoutGap="12px">
              <span class="night-darker text__medium">About archived listings</span>
              <span>
                {{ 'CORE.PRODUCT_NAME' | transloco }} imports all listings under the account, including archived
                listings.
              </span>
            </div>
            <div *ngIf="tab === 'cohosted'" class="listing-warning" fxLayout="column" fxLayoutGap="12px">
              <span class="night-darker text__medium">About co-hosted listings</span>
              <span>
                Co-hosted listings benefit from the same features as primary hosted listings, with a few minor
                exceptions.
                <a
                  href="https://my.hospitable.com/support-documentation/article/1073965-does-smartbnb-work-with-co-host-accounts"
                  target="_blank"
                  class="raspberry-darker">
                  Learn more
                </a>
                .
              </span>
            </div>

            <div class="listings-container">
              <ng-container *ngFor="let listing of listingReviews.listings">
                <div
                  *ngIf="listing.type === tab"
                  class="listing-row"
                  [class.bg-smoke-lighter]="listing.muted"
                  fxLayout
                  fxLayoutAlign="start center"
                  fxLayoutGap="12px">
                  <img fxFlex="24px 0 0" class="listing-img" [src]="listing.picture" />

                  <span fxFlex class="night text__medium" [class.strikethrough]="listing.muted">
                    {{ listing.name }}
                  </span>

                  <!-- <sbnb-button *ngIf="listing.muted && listing.property_id" type="secondary" size="mini" label="Unmute"
                    (click)="unmute(listing)"></sbnb-button>

                  <sbnb-button *ngIf="!listing.muted && listing.property_id" type="secondary" size="mini" label="Mute"
                    (click)="mute(listing)"></sbnb-button> -->
                </div>
              </ng-container>
            </div>
          </mat-tab>
        </mat-tab-group>
      </section>

      <ng-container [ngTemplateOutlet]="complete"></ng-container>
    </div>
  </ng-template>

  <ng-template #complete>
    <div
      fxLayout
      fxLayoutGap="18px"
      fxLayoutAlign="end center"
      fxLayout.lt-md="column"
      fxLayoutAlign.lt-md="center stretch">
      <sbnb-button [fullWidth]="true" [loading]="nextStepLoading" (click)="continue()">Continue</sbnb-button>
    </div>
  </ng-template>
</div>
